import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Result } from '../types';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface SurveyChartProps {
    question: string;
    results: Result[];
}

const SurveyChart: React.FC<SurveyChartProps> = ({ question, results }) => {
    const data = {
        labels: results.map(result => result.option),
        datasets: [
            {
                label: 'Responses',
                data: results.map(result => result.count),
                backgroundColor: 'rgba(61, 168, 226, 0.5)',
                borderColor: 'rgba(61, 168, 226, 1)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom' as const,
            },
            title: {
                display: true,
                text: question,
            },
        },
        scales: {
            x: {
                ticks: {
                    autoSkip: false,
                },
            },
        },
    };

    return (
        // <div className="chart-container">
            <Bar data={data} options={options} />
        // </div>
    );
    
};

export default SurveyChart;